function processNativeTabsScreens(screens) {
  return screens.map(function(screen) {
    if (typeof screen.options === "function") {
      var getOptions = screen.options;
      return {
        ...screen,
        options: function options(props) {
          var options2 = getOptions(props);
          assertNoNativeTabsHref(screen.name, options2);
          return options2;
        }
      };
    }
    assertNoNativeTabsHref(screen.name, screen.options);
    return screen;
  });
}
function assertNoNativeTabsHref(screenName, options) {
  if (options && "href" in options) {
    throw new Error(`Tabs.Screen "${screenName !== null && screenName !== void 0 ? screenName : ""}" uses the web-only href option. Native tabs use the route name. Put non-tab routes in a parent Stack, and move custom href options to a .web layout.`);
  }
}
export {
  processNativeTabsScreens
};
//# sourceMappingURL=nativeTabsOptions.js.map
